//@ts-nocheck
import { Box } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React from "react";
import { HourlyRate } from "./HourlyRate";
import { EditHourlyPrice } from "./EditHourlyPrice";
import { HowPricingWorks } from "./HowPricingWorks";
import { SetNewPrice } from "./SetNewPrice";

const pricingPages = {
  0: "How-pricing-works",
  1: "Set-new-pricing",
  2: "Edit-pricing",
  3: "View-pricing",
};

export const SetHourlyRate: React.FC<{
  initialValues: { hourlyRate: string };
  priceAgreement: boolean;
  priceSuggestion?: {
    minimum: number | string;
    maximum: number | string;
    recommended: number | string;
  };
  onBackClick: () => void;
  isLoading?: boolean;
  currency: string;
  subject?: string;
  earningPercentage?: number;
  updatePriceAgreement?: () => void;
  withholdingTax?: number;
  onSubmit: (values: any) => Promise<any>;
  onSavePrice: (values: any) => Promise<any>;
}> = observer(
  ({
    onBackClick,
    initialValues,
    priceSuggestion,
    currency,
    priceAgreement,
    withholdingTax,
    subject,
    earningPercentage,
    updatePriceAgreement,
    isLoading,
    onSubmit,
    onSavePrice,
  }) => {
    const initialPage = priceAgreement
      ? initialValues.hourlyRate
        ? pricingPages[3]
        : pricingPages[1]
      : pricingPages[0];

    const [pricingPage, setPricingPage] = React.useState(initialPage);
    const [backPage, setBackPage] = React.useState("");

    const howPricingWorks = pricingPage === pricingPages[0];
    const setNewPrice = pricingPage === pricingPages[1];
    const editPrice = pricingPage === pricingPages[2];
    const viewPrice = pricingPage === pricingPages[3];

    const handleBackClick = () => {
      if (editPrice) setPricingPage(pricingPages[3]);
      if (setNewPrice) {
        if (priceAgreement) {
          onBackClick();
        } else {
          setPricingPage(pricingPages[0]);
        }
      }
      if (howPricingWorks) {
        if (!priceAgreement) {
          onBackClick();
        } else {
          setPricingPage(backPage);
        }
      }
    };

    const handleSubmit = () => {
      if (!priceAgreement) {
        updatePriceAgreement();
        setPricingPage(pricingPages[1]);
      } else {
        setPricingPage(backPage);
      }
    };

    return (
      <Box className="set-hourly-price">
        {viewPrice && (
          <HourlyRate
            subject={subject}
            currency={currency}
            initialValues={initialValues}
            howPriceWorksClick={(step) => {
              setPricingPage(pricingPages[0]);
              setBackPage(step);
            }}
            earningPercentage={earningPercentage}
            priceSuggestion={priceSuggestion}
            isLoading={isLoading}
            onSubmit={onSubmit}
            onEditPrice={() => {
              setPricingPage(pricingPages[2]);
            }}
            onBackClick={onBackClick}
          />
        )}

        {editPrice && (
          <EditHourlyPrice
            subject={subject}
            currency={currency}
            withholdingTax={withholdingTax}
            howPriceWorksClick={(step) => {
              setPricingPage(pricingPages[0]);
              setBackPage(step);
            }}
            initialValues={{ ...initialValues }}
            earningPercentage={earningPercentage}
            priceSuggestion={priceSuggestion}
            isLoading={isLoading}
            onSubmit={async (formValues) => {
              await onSavePrice(formValues);
              setPricingPage(pricingPages[3]);
            }}
            onBackClick={handleBackClick}
          />
        )}

        {setNewPrice && (
          <SetNewPrice
            subject={subject}
            currency={currency}
            howPriceWorksClick={(step) => {
              setPricingPage(pricingPages[0]);
              setBackPage(step);
            }}
            withholdingTax={withholdingTax}
            initialValues={{ ...initialValues }}
            earningPercentage={earningPercentage}
            priceSuggestion={priceSuggestion}
            isLoading={isLoading}
            onSubmit={async (formValues) => {
              await onSavePrice(formValues);
              setPricingPage(pricingPages[3]);
            }}
            onBackClick={handleBackClick}
          />
        )}

        {howPricingWorks && (
          <HowPricingWorks
            priceAgreement={priceAgreement}
            withholdingTax={withholdingTax}
            earningPercentage={earningPercentage}
            onSubmit={handleSubmit}
            onBackClick={handleBackClick}
          />
        )}
      </Box>
    );
  },
);
